/**
 * Get the unicode code of an emoji in base 16.
 */
export function emojiUnicode(input: string, delimiter = ' '): string {
    return emojiToRawUnicode(input)
        .map((val) => val.toString(16))
        .join(delimiter);
}

/**
 * Get the unicode code points of an emoji in base 16 (raw).
 */
function emojiToRawUnicode(input: string): number[] {
    if (input.length === 1) {
        return [input.charCodeAt(0)];
    }

    if (input.length > 1) {
        const pairs: number[] = [];
        for (let i = 0; i < input.length; i++) {
            if (
                // high surrogate
                input.charCodeAt(i) >= 0xd800 &&
                input.charCodeAt(i) <= 0xdbff
            ) {
                if (input.charCodeAt(i + 1) >= 0xdc00 && input.charCodeAt(i + 1) <= 0xdfff) {
                    // low surrogate
                    pairs.push(
                        (input.charCodeAt(i) - 0xd800) * 0x400 +
                            (input.charCodeAt(i + 1) - 0xdc00) +
                            0x10000
                    );
                }
            } else if (input.charCodeAt(i) < 0xd800 || input.charCodeAt(i) > 0xdfff) {
                // modifiers and joiners
                pairs.push(input.charCodeAt(i));
            }
        }
        return pairs;
    }

    return [];
}
